// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ControllerLabelsMessage, ControllerLabelsMessageT } from "./controller-labels-message";
import {
  ControllerVersionInfoMessage,
  ControllerVersionInfoMessageT,
} from "./controller-version-info-message";
import { DispatcherVersionMessage, DispatcherVersionMessageT } from "./dispatcher-version-message";
import { FirmwareVersionMessage, FirmwareVersionMessageT } from "./firmware-version-message";
import { FloorLabelMessage, FloorLabelMessageT } from "./floor-label-message";
import { FloorLabelsDataMessage, FloorLabelsDataMessageT } from "./floor-labels-data-message";
import {
  FloorPhysicalOpeningsMessage,
  FloorPhysicalOpeningsMessageT,
} from "./floor-physical-openings-message";
import {
  HallCallEligibilityMessage,
  HallCallEligibilityMessageT,
} from "./hall-call-eligibility-message";
import { JobNameMessage, JobNameMessageT } from "./job-name-message";
import { ShuttleFloorsMessage, ShuttleFloorsMessageT } from "./shuttle-floors-message";

export enum ControllerInfoContent {
  NONE = 0,
  FloorLabelMessage = 1,
  FirmwareVersionMessage = 2,
  ControllerLabelsMessage = 3,
  FloorLabelsDataMessage = 4,
  DispatcherVersionMessage = 5,
  ControllerVersionInfoMessage = 6,
  JobNameMessage = 7,
  FloorPhysicalOpeningsMessage = 8,
  HallCallEligibilityMessage = 9,
  ShuttleFloorsMessage = 10,
}

export function unionToControllerInfoContent(
  type: ControllerInfoContent,
  accessor: (
    obj:
      | ControllerLabelsMessage
      | ControllerVersionInfoMessage
      | DispatcherVersionMessage
      | FirmwareVersionMessage
      | FloorLabelMessage
      | FloorLabelsDataMessage
      | FloorPhysicalOpeningsMessage
      | HallCallEligibilityMessage
      | JobNameMessage
      | ShuttleFloorsMessage,
  ) =>
    | ControllerLabelsMessage
    | ControllerVersionInfoMessage
    | DispatcherVersionMessage
    | FirmwareVersionMessage
    | FloorLabelMessage
    | FloorLabelsDataMessage
    | FloorPhysicalOpeningsMessage
    | HallCallEligibilityMessage
    | JobNameMessage
    | ShuttleFloorsMessage
    | null,
):
  | ControllerLabelsMessage
  | ControllerVersionInfoMessage
  | DispatcherVersionMessage
  | FirmwareVersionMessage
  | FloorLabelMessage
  | FloorLabelsDataMessage
  | FloorPhysicalOpeningsMessage
  | HallCallEligibilityMessage
  | JobNameMessage
  | ShuttleFloorsMessage
  | null {
  switch (ControllerInfoContent[type]) {
    case "NONE":
      return null;
    case "FloorLabelMessage":
      return accessor(new FloorLabelMessage())! as FloorLabelMessage;
    case "FirmwareVersionMessage":
      return accessor(new FirmwareVersionMessage())! as FirmwareVersionMessage;
    case "ControllerLabelsMessage":
      return accessor(new ControllerLabelsMessage())! as ControllerLabelsMessage;
    case "FloorLabelsDataMessage":
      return accessor(new FloorLabelsDataMessage())! as FloorLabelsDataMessage;
    case "DispatcherVersionMessage":
      return accessor(new DispatcherVersionMessage())! as DispatcherVersionMessage;
    case "ControllerVersionInfoMessage":
      return accessor(new ControllerVersionInfoMessage())! as ControllerVersionInfoMessage;
    case "JobNameMessage":
      return accessor(new JobNameMessage())! as JobNameMessage;
    case "FloorPhysicalOpeningsMessage":
      return accessor(new FloorPhysicalOpeningsMessage())! as FloorPhysicalOpeningsMessage;
    case "HallCallEligibilityMessage":
      return accessor(new HallCallEligibilityMessage())! as HallCallEligibilityMessage;
    case "ShuttleFloorsMessage":
      return accessor(new ShuttleFloorsMessage())! as ShuttleFloorsMessage;
    default:
      return null;
  }
}

export function unionListToControllerInfoContent(
  type: ControllerInfoContent,
  accessor: (
    index: number,
    obj:
      | ControllerLabelsMessage
      | ControllerVersionInfoMessage
      | DispatcherVersionMessage
      | FirmwareVersionMessage
      | FloorLabelMessage
      | FloorLabelsDataMessage
      | FloorPhysicalOpeningsMessage
      | HallCallEligibilityMessage
      | JobNameMessage
      | ShuttleFloorsMessage,
  ) =>
    | ControllerLabelsMessage
    | ControllerVersionInfoMessage
    | DispatcherVersionMessage
    | FirmwareVersionMessage
    | FloorLabelMessage
    | FloorLabelsDataMessage
    | FloorPhysicalOpeningsMessage
    | HallCallEligibilityMessage
    | JobNameMessage
    | ShuttleFloorsMessage
    | null,
  index: number,
):
  | ControllerLabelsMessage
  | ControllerVersionInfoMessage
  | DispatcherVersionMessage
  | FirmwareVersionMessage
  | FloorLabelMessage
  | FloorLabelsDataMessage
  | FloorPhysicalOpeningsMessage
  | HallCallEligibilityMessage
  | JobNameMessage
  | ShuttleFloorsMessage
  | null {
  switch (ControllerInfoContent[type]) {
    case "NONE":
      return null;
    case "FloorLabelMessage":
      return accessor(index, new FloorLabelMessage())! as FloorLabelMessage;
    case "FirmwareVersionMessage":
      return accessor(index, new FirmwareVersionMessage())! as FirmwareVersionMessage;
    case "ControllerLabelsMessage":
      return accessor(index, new ControllerLabelsMessage())! as ControllerLabelsMessage;
    case "FloorLabelsDataMessage":
      return accessor(index, new FloorLabelsDataMessage())! as FloorLabelsDataMessage;
    case "DispatcherVersionMessage":
      return accessor(index, new DispatcherVersionMessage())! as DispatcherVersionMessage;
    case "ControllerVersionInfoMessage":
      return accessor(index, new ControllerVersionInfoMessage())! as ControllerVersionInfoMessage;
    case "JobNameMessage":
      return accessor(index, new JobNameMessage())! as JobNameMessage;
    case "FloorPhysicalOpeningsMessage":
      return accessor(index, new FloorPhysicalOpeningsMessage())! as FloorPhysicalOpeningsMessage;
    case "HallCallEligibilityMessage":
      return accessor(index, new HallCallEligibilityMessage())! as HallCallEligibilityMessage;
    case "ShuttleFloorsMessage":
      return accessor(index, new ShuttleFloorsMessage())! as ShuttleFloorsMessage;
    default:
      return null;
  }
}

export type ControllerInfoContentT =
  | { type: "NONE"; value: null }
  | { type: "FloorLabelMessage"; value: FloorLabelMessageT }
  | { type: "FirmwareVersionMessage"; value: FirmwareVersionMessageT }
  | { type: "ControllerLabelsMessage"; value: ControllerLabelsMessageT }
  | { type: "FloorLabelsDataMessage"; value: FloorLabelsDataMessageT }
  | { type: "DispatcherVersionMessage"; value: DispatcherVersionMessageT }
  | { type: "ControllerVersionInfoMessage"; value: ControllerVersionInfoMessageT }
  | { type: "JobNameMessage"; value: JobNameMessageT }
  | { type: "FloorPhysicalOpeningsMessage"; value: FloorPhysicalOpeningsMessageT }
  | { type: "HallCallEligibilityMessage"; value: HallCallEligibilityMessageT }
  | { type: "ShuttleFloorsMessage"; value: ShuttleFloorsMessageT };
